export default "__VITE_ASSET__CQN1ycdE__"